import { useSyncExternalStore } from "react";

const EMPTY_SUBSCRIBE = () => () => {};

// True when the page is running inside the Storyblok visual editor (or any
// other iframe embed). Used to suppress analytics/marketing tags so editor
// activity never pollutes the data.
export function isEmbedded(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const inIframe = window.self !== window.top;
    const isStoryblokPreview =
      window.location.search.includes("_storyblok") ||
      document.referrer.includes("app.storyblok.com");
    return inIframe || isStoryblokPreview;
  } catch {
    // Cross-origin window access throws — that itself means we're embedded.
    return true;
  }
}

export function useIsEmbedded(): boolean {
  return useSyncExternalStore(EMPTY_SUBSCRIBE, isEmbedded, () => false);
}
